import { render, staticRenderFns } from "./index.vue?vue&type=template&id=25b133b6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=25b133b6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b133b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25b133b6')) {
      api.createRecord('25b133b6', component.options)
    } else {
      api.reload('25b133b6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=25b133b6&scoped=true", function () {
      api.rerender('25b133b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/zdy_dragging/component/left/elevatorNavigation/index.vue"
export default component.exports